// extracted by mini-css-extract-plugin
export default {"profileform":"admin_profileform__I35+G","tabletitle":"admin_tabletitle__fQrou","result_btn":"admin_result_btn__BCB6h","noData":"admin_noData__jDgZn"};